// Edge auto-scroll while dragging furniture: bring the dragged item near a screen
// edge and the camera pans that way (like dragging a file to the bottom of a
// browser page), faster the closer to the edge. Screen px — same feel at any zoom.

/** How far from a screen edge the pan starts. */
export const EDGE_ZONE_PX = 56;
/** Pan speed right at the edge, screen px per 60 fps frame. */
export const EDGE_MAX_SPEED_PX = 12;

/**
 * Camera velocity (screen px per frame) for a pointer at (x, y) on a w×h screen:
 * negative = towards the left/top edge. Zero in the middle of the screen; ramps up
 * quadratically inside the edge zone so a near-edge touch drifts, an at-edge one runs.
 * `liftPx`: the dragged item is shown that far above the pointer, so the TOP edge
 * is measured from there (the item reaches it first); the bottom from the pointer.
 */
export function edgeScrollVelocity(
  x: number,
  y: number,
  width: number,
  height: number,
  liftPx = 0,
  zone: number = EDGE_ZONE_PX,
  maxSpeed: number = EDGE_MAX_SPEED_PX,
): { dx: number; dy: number } {
  const toStart = (p: number) => (p < zone ? -maxSpeed * ((zone - Math.max(0, p)) / zone) ** 2 : 0);
  const toEnd = (p: number, size: number) =>
    p > size - zone ? maxSpeed * ((Math.min(size, p) - (size - zone)) / zone) ** 2 : 0;
  return { dx: toStart(x) + toEnd(x, width), dy: toStart(y - liftPx) + toEnd(y, height) };
}
